import DOMPurify from 'dompurify';
interface ISanitizedProps {
  description: string;
}
const Sanitized = ({ description }: ISanitizedProps) => {
  const sanitizedHtml = DOMPurify.sanitize(description);
  return <div dangerouslySetInnerHTML={{ __html: sanitizedHtml }}></div>;
};

export default Sanitized;
